import { TableBody, TableHead, TableRow } from '@mui/material';
import type { NsnReport } from '@physna/core/domain/nsn-report/nsn-report';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

export const NsnSummaryTable = ({ nsnReport }: { nsnReport: NsnReport }) => {
  const { nsn, description, assignDate, endItemDescription, criticality, agencyUsage, managementPrice } = nsnReport;
  return (
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell sx={{ width: '17.5%' }}>NSN</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '32.5%' }}>Description</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '90px' }}>Assign Date</StyledHeaderCell>
          <StyledHeaderCell sx={{ width: '150px' }}>End Item Description</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableRow>
          <StyledTableCell sx={{ width: '17.5%', fontWeight: 600 }}>{nsn}</StyledTableCell>
          <StyledTableCell sx={{ width: '32.5%' }}>{description ?? ''}</StyledTableCell>
          <StyledTableCell sx={{ width: '90px' }}>{assignDate ?? ''}</StyledTableCell>
          <StyledTableCell sx={{ width: '150px' }}>{endItemDescription ?? ''}</StyledTableCell>
        </StyledTableRow>
      </TableBody>
      <TableHead>
        <TableRow>
          <StyledHeaderCell>Agency Usage</StyledHeaderCell>
          <StyledHeaderCell>Management Price</StyledHeaderCell>
          <StyledHeaderCell colSpan={2}>Criticality</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <StyledTableRow>
          <StyledTableCell>
            {agencyUsage.length > 0
              ? agencyUsage.map((agency, index) => (
                  <span key={`agency-${agency}-${index}`}>
                    {agency}
                    {index < agencyUsage.length - 1 && <br />}
                  </span>
                ))
              : ''}
          </StyledTableCell>

          <StyledTableCell sx={{ fontWeight: 600 }}>
            {managementPrice === undefined ? '' : `$${managementPrice.toFixed(2)}`}
          </StyledTableCell>
          <StyledTableCell colSpan={2} sx={criticality ? { color: 'warning.main', fontWeight: 500 } : undefined}>
            {criticality}
          </StyledTableCell>
        </StyledTableRow>
      </TableBody>
    </StyledTable>
  );
};
